import axios from "axios";

export const HTTP = axios.create({
  //  baseURL: `https://js9gl3pu74.execute-api.us-west-2.amazonaws.com/dev/`,
  //  baseURL: `https://8z7t07432l.execute-api.us-west-2.amazonaws.com/test/`,
  baseURL: `https://1p6i61z7c2.execute-api.us-west-2.amazonaws.com/UAT/`,
  //baseURL: `https://sphbfj9v46.execute-api.us-west-2.amazonaws.com/Prod/`,
});

export const HTTP_GAP = axios.create({
//  baseURL: `https://tpi8ouopzd.execute-api.us-west-2.amazonaws.com/dev/`,
  //  baseURL: `https://hnhk4ugvu6.execute-api.us-west-2.amazonaws.com/test/`,
  baseURL: `https://egwj6ngd0d.execute-api.us-west-2.amazonaws.com/UAT`,
  //baseURL: `https://x6hjpszpoi.execute-api.us-west-2.amazonaws.com/Prod`,
});

export const HTTP_LNLADMIN = axios.create({
  baseURL: `https://7a27v7mo05.execute-api.us-west-2.amazonaws.com/dev/`
});

export const HTTP_LND = axios.create({
  //  baseURL: `https://00fj4leww8.execute-api.us-west-2.amazonaws.com/dev/`,
  // baseURL: `https://98983cyo6k.execute-api.us-west-2.amazonaws.com/Test/`,
  baseURL: `https://4th8iag2ie.execute-api.us-west-2.amazonaws.com/STAGE/`,
  //baseURL: `https://vrvhp3h249.execute-api.us-west-2.amazonaws.com/prod`,
});